import { SET_ORG_STORAGE_DATA, SET_ORG_STORAGE_STATE } from "../Constants";

export const setPlanOrgStorage = (key: string, storage: any) => ({
  type: SET_ORG_STORAGE_DATA,
  payload: { key, storage },
});

export const setPlanOrgStorageState = () => ({
  type: SET_ORG_STORAGE_STATE,
});
